import { defineMetabaseAuthConfig } from '@metabase/embedding-sdk-react';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { metabaseInstanceUrl } from './constants';

export const authConfig = defineMetabaseAuthConfig({
  metabaseInstanceUrl,
  preferredAuthMethod: 'jwt',
  fetchRequestToken: async () => {
    const response = await api.request(endpoints.internal.getMetabaseJWT());
    return { jwt: response.jwt };
  },
});
